module.exports = __webpack_public_path__ + "img/creditos-img.689712e2.svg";